// Shared dashboard formatters and color constants.
// Kept tiny + dependency-free so it can be imported from any dashboard sub-component.

export const fmtMoney = (n, compact = true) => {
  const v = Number(n || 0);
  if (compact) {
    if (Math.abs(v) >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
    if (Math.abs(v) >= 1_000) return `$${(v / 1_000).toFixed(0)}K`;
  }
  return `$${Math.round(v).toLocaleString()}`;
};

export const fmtPct = (n) => `${(n ?? 0).toFixed(1)}%`;

export const fmtNum = (n) => new Intl.NumberFormat("en-US").format(n || 0);

export const RISK_TONE = {
  High: {
    color: "#FCA5A5",
    bg: "rgba(248,113,113,0.18)",
    border: "rgba(248,113,113,0.55)",
    dot: "#FCA5A5",
  },
  Medium: {
    color: "#FCD34D",
    bg: "rgba(251,191,36,0.18)",
    border: "rgba(251,191,36,0.55)",
    dot: "#FCD34D",
  },
  Low: {
    color: "#86EFAC",
    bg: "rgba(74,222,128,0.18)",
    border: "rgba(74,222,128,0.55)",
    dot: "#86EFAC",
  },
};
